module.exports = __webpack_public_path__ + "img/people-asking-questions-illustration.f43dd8d0.png";